module.exports = __webpack_public_path__ + "static/media/Fingerspiele.ec24fd3e.pdf";